<h2 mat-dialog-title class="!mb-0">{{ 'waters.media.edit.title' | translate }}</h2>
@if (detail(); as d) {
  <p class="px-6 -mt-2 mb-2 text-sm text-gray-500">{{ d.waterTitle }}</p>
}

<mat-dialog-content>
  @if (isLoading()) {
    <div class="flex justify-center items-center py-10">
      <mat-spinner diameter="40" />
    </div>
  } @else if (detail(); as d) {
    <!-- Thumbnail preview -->
    @if (thumbUrl()) {
      <div class="flex justify-center mb-4">
        <img [src]="thumbUrl()" [alt]="''" class="max-h-48 rounded-lg object-contain" />
      </div>
    }

    <form [formGroup]="form" class="flex flex-col gap-4">
      <!-- Submitter (readonly) -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <p class="text-xs font-medium text-gray-500">{{ 'waters.media.edit.name' | translate }}</p>
          <p class="text-sm">{{ d.name || '—' }}</p>
        </div>
        <div>
          <p class="text-xs font-medium text-gray-500">{{ 'waters.media.edit.email' | translate }}</p>
          <p class="text-sm">{{ d.email || '—' }}</p>
        </div>
      </div>

      <!-- Label / tag -->
      <mat-form-field>
        <mat-label>{{ 'waters.media.edit.tag' | translate }}</mat-label>
        <mat-select formControlName="tag">
          <mat-option [value]="null">—</mat-option>
          @for (tag of tags; track tag) {
            <mat-option [value]="tag">{{ 'waters.media.tag.' + tag | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- YouTube URL -->
      <mat-form-field>
        <mat-label>{{ 'waters.media.edit.videoUrl' | translate }}</mat-label>
        <input matInput formControlName="videoUrl" />
        @if (form.controls.videoUrl.hasError('youtube')) {
          <mat-error>{{ 'waters.media.edit.video-invalid' | translate }}</mat-error>
        }
      </mat-form-field>

      <!-- Accommodation -->
      <mat-form-field>
        <mat-label>{{ 'waters.media.edit.accommodation' | translate }}</mat-label>
        <mat-select formControlName="accommodationId">
          <mat-option [value]="null">{{ 'waters.media.edit.none' | translate }}</mat-option>
          @for (a of accommodations(); track a.id) {
            <mat-option [value]="a.id">{{ a.name }} ({{ a.number }})</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Swim / fishing spot -->
      <mat-form-field>
        <mat-label>{{ 'waters.media.edit.spot' | translate }}</mat-label>
        <mat-select formControlName="spotId">
          <mat-option [value]="null">{{ 'waters.media.edit.none' | translate }}</mat-option>
          @for (s of spots(); track s.id) {
            <mat-option [value]="s.id">{{ s.title }} ({{ s.number }})</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Description (multilang) -->
      <div>
        <p class="text-sm font-medium text-gray-700 mb-2">{{ 'waters.media.edit.description' | translate }}</p>
        <app-localized-text-editor
          [nl]="form.controls.descriptionNl"
          [en]="form.controls.descriptionEn"
          [de]="form.controls.descriptionDe"
          [it]="form.controls.descriptionIt"
          [fr]="form.controls.descriptionFr" />
      </div>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matButton (click)="cancel()" [disabled]="isSaving()">{{ 'waters.media.edit.cancel' | translate }}</button>
  <button matButton="filled" color="primary" (click)="save()" [disabled]="isLoading() || isSaving()">
    @if (isSaving()) {
      <mat-spinner diameter="18" />
    } @else {
      {{ 'waters.media.edit.save' | translate }}
    }
  </button>
</mat-dialog-actions>
